import o from "./index.ce.vue2.js";
import t from "./index.ce.vue3.js";
import r from "../../_virtual/_plugin-vue_export-helper.js";
const s = /* @__PURE__ */ r(o, [["styles", [t]]]);
export {
  s as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/related-approval/index.ce.vue.js
// module id = 1326
// module chunks = 67